module.exports = __webpack_public_path__ + "static/img/tooth.7082355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_icons/tooth.png
// module id = uMaJ
// module chunks = 1